export const GET_COMMISSION = "GET_COMMISSION";
export const CREATE_NEW_COMMISSION = "CREATE_NEW_COMMISSION";
export const EDIT_COMMISSION = "EDIT_COMMISSION";
export const DELETE_COMMISSION = "DELETE_COMMISSION";

export const VIP_SWITCH = "VIP_SWITCH";

export const OPEN_COMMISSION_DIALOG = "OPEN_COMMISSION_DIALOG";
export const CLOSE_COMMISSION_DIALOG = "CLOSE_COMMISSION_DIALOG";
